/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Aborted_ToastInputs */

const en_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed job was aborted`)
};

const fr_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tache d'incrustation a ete annulee`)
};

const de_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Einbettungsvorgang wurde abgebrochen.`)
};

const it_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il processo di incorporamento è stato interrotto`)
};

const ru_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание было прервано.`)
};

const es_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El trabajo de inserción fue cancelado`)
};

const zh_cn2_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入作业已中止`)
};

const ja_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`埋め込みジョブが中止されました`)
};

const hi_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एम्बेड जॉब रद्द कर दिया गया`)
};

const pt_pt2_embed_captions_aborted_toast = /** @type {(inputs: Embed_Captions_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tarefa de incorporação foi abortada.`)
};

/**
* | output |
* | --- |
* | "Embed job was aborted" |
*
* @param {Embed_Captions_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_aborted_toast = /** @type {((inputs?: Embed_Captions_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_aborted_toast(inputs)
	if (locale === "de") return de_embed_captions_aborted_toast(inputs)
	if (locale === "it") return it_embed_captions_aborted_toast(inputs)
	if (locale === "ru") return ru_embed_captions_aborted_toast(inputs)
	if (locale === "es") return es_embed_captions_aborted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_aborted_toast(inputs)
	if (locale === "ja") return ja_embed_captions_aborted_toast(inputs)
	if (locale === "hi") return hi_embed_captions_aborted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_aborted_toast(inputs)
	return en_embed_captions_aborted_toast(inputs)
});